'use strict';

var actionBacklogSnsEvents = require('./actionBacklogSnsEvents');
var deliverySnsEvents = require('./deliverySnsEvents');
var deviceSnsEvents = require('./deviceSnsEvents');
var endpointSnsEvents = require('./endpointSnsEvents');
var hotFolderSnsEvents = require('./hotFolderSnsEvents');
var jetTransferSnsEvents = require('./jetTransferSnsEvents');
var jobSnsEvents = require('./jobSnsEvents');
var serviceRoleSnsEvents = require('./serviceRoleSnsEvents');
var storageProfileSnsEvents = require('./storageProfileSnsEvents');
var msPortalSnsEvents = require('./msPortalSnsEvents');
var msPortalAuthConfigSnsEvents = require('./msPortalAuthConfigSnsEvents');

module.exports = {
    actionBacklogSnsEvents: actionBacklogSnsEvents,
    deliverySnsEvents: deliverySnsEvents,
    deviceSnsEvents: deviceSnsEvents,
    endpointSnsEvents: endpointSnsEvents,
    hotFolderSnsEvents: hotFolderSnsEvents,
    jetTransferSnsEvents: jetTransferSnsEvents,
    jobSnsEvents: jobSnsEvents,
    serviceRoleSnsEvents: serviceRoleSnsEvents,
    storageProfileSnsEvents: storageProfileSnsEvents,
    msPortalSnsEvents: msPortalSnsEvents,
    msPortalAuthConfigSnsEvents: msPortalAuthConfigSnsEvents
};